import React from "react";
import { storyblokEditable } from "@storyblok/react";

const SeminarTextColumn = ({ blok }) => (
  <div className="wrap">
  <div className="inner-wrap seminartextcolumn-wrap" {...storyblokEditable(blok)}>
    <div className="seminartextcolumn-element">
        <h2 className="text-2xl pb-1">{blok.subheadline1}</h2>
        <p>{blok.text1}</p>
    </div>

    <div className="seminartextcolumn-element">
        <h2 className="text-2xl pb-1">{blok.subheadline2}</h2>
        <p>{blok.text2}</p>
    </div>

    <div className="seminartextcolumn-element">
        <h2 className="text-2xl pb-1">{blok.subheadline3}</h2>
        <p>{blok.text3}</p>
    </div>
  </div>
  </div>
);

export default SeminarTextColumn;
